// extracted by mini-css-extract-plugin
module.exports = {"no-recruiter-access":"styles__no-recruiter-access___okxXw"};